import { Form } from 'antd';
import { useTranslation } from 'react-i18next';
import MySelect from '../mySelect/MySelect';
import { useMemo } from 'react';

const COLOR_OPTIONS = [
  { labelKey: 'WORD_COLOR_BLUE', value: 'blue', hex: '#1d4ed8' },
  { labelKey: 'WORD_COLOR_INDIGO', value: 'indigo', hex: '#4f46e5' },
  { labelKey: 'WORD_COLOR_VIOLET', value: 'violet', hex: '#7c3aed' },
  { labelKey: 'WORD_COLOR_GREEN', value: 'green', hex: '#16a34a' },
  { labelKey: 'WORD_COLOR_TEAL', value: 'teal', hex: '#0d9488' },
  { labelKey: 'WORD_COLOR_CYAN', value: 'cyan', hex: '#0891b2' },
  { labelKey: 'WORD_COLOR_RED', value: 'red', hex: '#dc2626' },
  { labelKey: 'WORD_COLOR_ORANGE', value: 'orange', hex: '#ea580c' },
  { labelKey: 'WORD_COLOR_PINK', value: 'pink', hex: '#db2777' },
  { labelKey: 'WORD_COLOR_SLATE', value: 'slate', hex: '#475569' },
];

export { COLOR_OPTIONS };

const ColorDot = ({ color }) => (
  <span
    style={{
      display: 'inline-block',
      width: 12,
      height: 12,
      borderRadius: '50%',
      backgroundColor: color,
      marginInlineEnd: 8,
      verticalAlign: 'middle',
      border: '1px solid rgba(0,0,0,0.12)',
    }}
  />
);

const SelectPrimaryColor = ({
  name,
  label,
  style,
  block,
  width,
  hidden,
  required,
  placeholder,
  errorMessage,
  disableMargins,
  className = '',
  ...otherProps
}) => {
  const { t } = useTranslation();

  const options = useMemo(
    () =>
      COLOR_OPTIONS.map((item) => ({
        label: (
          <span>
            <ColorDot color={item.hex} />
            {t(item.labelKey)}
          </span>
        ),
        value: item.value,
      })),
    [t]
  );

  const styleLocal = { ...style, width: block ? '100%' : width || '' };

  const select = (
    <MySelect
      {...otherProps}
      block={block}
      width={width}
      options={options}
      placeholder={placeholder || label || ''}
    />
  );

  if (!name) return select;

  return (
    <Form.Item
      name={name}
      label={label}
      hidden={hidden}
      style={styleLocal}
      rules={[
        {
          required: required && !hidden,
          message:
            errorMessage ||
            `${placeholder || label} ${t('WORD_IS_REQUIRED')}`,
        },
      ]}
      className={`${className} ${disableMargins ? 'disable_margins' : ''}`}
    >
      {select}
    </Form.Item>
  );
};

export default SelectPrimaryColor;
